import styled from "styled-components";
import {
  MobileWidth,
  PrimaryColor,
  SectionPadding,
  SectionPaddingMobile,
} from "../../GlobalStyle";

import AboutBg from "../../images/about-bg.jpg";

export const AboutWrapper = styled.div`
  background: url(${AboutBg}) center / cover no-repeat;
  color: #fff;
  padding: ${SectionPadding};
  text-align: center;
  @media screen and (max-width: ${MobileWidth}) {
    padding: ${SectionPaddingMobile};
  }

  img {
    margin-top: 30px;
    width: 400px;
    @media screen and (max-width: ${MobileWidth}) {
      margin: 10px 0;
      width: 100%;
    }
  }

  .about-us-images {
    height: 100px;
    width: 400px;
    margin: auto;
    @media screen and (max-width: ${MobileWidth}) {
      width: 100%;
    }
    .carousel {
      height: 100%;
      .carousel-item {
        width: calc(100% / 3 - 5px);
        height: 100%;
        background-size: cover;
        background-position: center;
        margin-right: 5px;
      }
      .flickity-page-dots {
        display: none;
      }
    }
  }

  .paragraph-wrapper {
    margin: auto;
    max-width: 750px;
    width: 90%;

    @media screen and (max-width: ${MobileWidth}) {
      width: 100%;
    }
    a {
       color: ${PrimaryColor};
    }
    p {
      @media screen and (max-width: ${MobileWidth}) {
        font-size: 12px;
      }
    }
  }
`;
